<template>
  <div id="apf">
    <div v-if="!isSubmitted && !isDraft" class="container">
      <img src="https://kws.etonhouse.com/images/mis_logo.png" style="width: 360px; padding-block: 20px; margin-bottom: 20px" />

      <h4 class="text-red">Student Registration Form</h4>
      <div class="row" style="margin: 0 0 25px 0">
        <p class="ps-0">Thank you for choosing our school for your child, we look forward to welcoming you and your family to our community.</p>

        <el-collapse v-model="termsAccordion" @change="termsAccordion = !termsAccordion" class="mb-3">
          <el-collapse-item
            title="By completing and submitting the Student Registration Form for your child you are
                        confirming that you have read and understood the following;"
            name="1"
          >
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSe9OwyUaXnPwKEyP0FUANrIiQ2bFqzN_My1Uh0pUbU6orzKew/viewform" target="_blank"
              >Pre-Course Counselling - TAMPINES</a
            ><br />
            <a href="https://kws.etonhouse.com/images/MIS_Parent_Handbook.pdf" target="_blank">Parent Handbook</a><br /><br />

            <ApfDeclarationAndAgreement :validator="$v" group="MIS" style="margin-bottom: 2rem" />

            <div class="border-bottom mb-2"></div>
            <div :class="{ 'form-group--error': $v.agreeTerms2.$error }">
              <el-checkbox v-model="agreeTerms2" @change="onAgreementUncheck">
                <span class="text-primary">I have read and acknowledged the Terms and Conditions*</span>
              </el-checkbox>
              <div class="error requiredFieldsMsg" v-if="!$v.agreeTerms2.required" style="margin-bottom: 10px">
                <el-alert title="Please read and acknowledge the Terms and Conditions." type="error"></el-alert>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>

        <p class="ps-0">
          You will also be required to provide important documentation as part of the registration process and you will need to ensure that the documents
          provided are certified to be true.
        </p>
      </div>

      <div class="row" style="margin: 0 0 45px 0">
        <ApfSelectSchoolDropdown :school="selectOptSchool" @change="selectOptSchool = $event" :validator="$v.selectOptSchool" group="MIS" />
      </div>

      <div v-show="selectOptSchool && showForm">
        <div class="saf-step-container" style="margin-bottom: 30px">
          <el-steps :active="currentStep">
            <el-step v-for="(item, index) in misSteps" :title="item.title" :key="index" :description="item.desc" @click.native="clickStep(index)"></el-step>
          </el-steps>
        </div>

        <div>
          <span style="display: block; color: #dc2826; font-weight: bold">Step {{ currentStep + 1 }}</span>
        </div>

        <div class="saf-student-details-cotainer" v-if="currentStep === 0" style="position: relative">
          <div style="margin-bottom: 20px">
            <label class="common-label-title">Student Details</label>
          </div>
          <div :class="{ 'form-group--error': $v.uploadedStuImg.$error }" class="mb-5">
            <ApfBasicInput name="uploadedStuImg" :validator="$v">
              <ApfUploadStudentPhoto group="MIS" @change="onFileChanged($event, 'stuIMG')" :currentStuImg="currentStudentImgPreview" />
            </ApfBasicInput>
          </div>
          <div style="display: grid; grid-template-columns: 1fr 1fr; row-gap: 1.5rem; column-gap: 3rem">
            <ApfBasicInput name="studFirstName" label="Given Name (as shown in passport)" :validator="$v">
              <input class="form-control" type="text" v-model="studFirstName" />
            </ApfBasicInput>

            <ApfBasicInput name="studLastName" label="Surname/Family Name (as shown in passport)" :validator="$v">
              <input class="form-control" type="text" v-model="studLastName" />
            </ApfBasicInput>

            <ApfBasicInput name="studDOB" label="Date of Birth" :validator="$v">
              <el-date-picker
                type="date"
                v-model="studDOB"
                format="dd/MM/yyyy"
                value-format="dd/MM/yyyy"
                placeholder="Pick a day"
                :picker-options="datePicker"
              />
            </ApfBasicInput>

            <ApfBasicInput name="inputFirstCommencementDate" label="Proposed Commencement Date" :validator="$v">
              <el-date-picker
                type="date"
                v-model="inputFirstCommencementDate"
                format="dd/MM/yyyy"
                value-format="dd/MM/yyyy"
                placeholder="Pick a day"
                :picker-options="CommDatePicker"
                @change="checkStudentAge()"
              />
            </ApfBasicInput>

            <ApfBasicInput name="studGender" label="Gender" :validator="$v">
              <select class="form-control" v-model="studGender">
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </ApfBasicInput>

            <ApfBasicInput name="studCOB" label="Country of Birth" :validator="$v">
              <select class="form-control w-full" v-model="studCOB">
                <option v-for="items in arrCountryList" :key="`COB_${items.CNYid}`" :value="items.CNYname.trim()">
                  {{ items.CNYname }}
                </option>
              </select>
            </ApfBasicInput>

            <ApfBasicInput name="studNationality" label="Nationality" :validator="$v">
              <select class="form-control w-full" v-model="studNationality">
                <option v-for="items in arrCountryList" :key="`SN_${items.CNYid}`" :value="items.CNYnationality.trim()">
                  {{ items.CNYnationality }}
                </option>
              </select>
            </ApfBasicInput>

            <ApfBasicInput label="If dual citizenship, please select:">
              <select class="form-control w-full" v-model="studDualCitizenship">
                <option v-for="items in arrCountryList" :key="`SN2_${items.CNYid}`" :value="items.CNYnationality.trim()">
                  {{ items.CNYnationality }}
                </option>
              </select>
            </ApfBasicInput>

            <ApfBasicInput name="passportNumber" label="Passport No." :validator="$v">
              <input class="form-control" type="text" v-model="passportNumber" />
            </ApfBasicInput>

            <ApfBasicInput name="passportExpiryDate" label="Passport Expiry Date" :validator="$v">
              <el-date-picker type="date" v-model="passportExpiryDate" format="dd/MM/yyyy" value-format="dd/MM/yyyy" placeholder="Pick a day" />
            </ApfBasicInput>
            <MisApfResidencyInputs
              @onResidencyChange="onResidencyChange"
              type="child"
              class="col-span-full"
              :columns="2"
              :form="this"
              :validator="$v"
              group="MIS"
              :fields="{
                status: 'studImmigrationStatus',
                number: 'studImmigrationStatusNo',
                expiry: 'studImmigrationStatusNoExpiryDate',
                issueDate: 'studImmigrationStatusNoIssueDate',
              }"
            />

            <ApfBasicInput name="studCurrentSchName" label="Current School Name" :validator="$v">
              <input class="form-control" type="text" v-model="studCurrentSchName" />
            </ApfBasicInput>

            <ApfBasicInput name="studCurrentSchCountry" label="Current School Country" :validator="$v">
              <select class="form-control w-full" v-model="studCurrentSchCountry">
                <option v-for="items in arrCountryList" :key="`SSC_${items.CNYid}`" :value="items.CNYname.trim()">
                  {{ items.CNYname }}
                </option>
              </select>
            </ApfBasicInput>

            <ApfBasicInput name="studIsEnrolled" :validator="$v" label="Has your child been enrolled with EtonHouse / Middleton previously?">
              <select class="form-control" v-model="studIsEnrolled">
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </ApfBasicInput>

            <ApfBasicInput v-if="studIsEnrolled === 'yes'" label="Please select which EtonHouse / Middleton campus">
              <div style="display: flex; gap: 0.5rem">
                <select class="form-control" v-model="studPrevEhSchool">
                  <option v-for="opt in schoolNameList" :value="opt.SchoolID" :key="opt.id">
                    {{ opt.SchoolName }}
                    <template v-if="opt.SchoolID === 'SCH201500000043' || opt.SchoolID === 'SCH201400000537'"> (Pre-School) </template>
                  </option>
                </select>
                <input class="form-control" placeholder="Year Attended" v-model="studPrevEhSchoolYear" style="width: 8rem" />
              </div>
            </ApfBasicInput>

            <ApfBasicInput name="studFirstLanguage" label="First(1st) Language" :validator="$v">
              <input class="form-control" type="text" v-model="studFirstLanguage" />
            </ApfBasicInput>

            <ApfBasicInput label="Second(2nd) Language (if applicable)">
              <input class="form-control" type="text" v-model="studSecondLanguage" />
            </ApfBasicInput>

            <ApfBasicInput label="Does your child have siblings?">
              <select class="form-control" v-model="isStudHasSibling">
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </ApfBasicInput>

            <ApfBasicInput style="grid-column: 1/-1" label="Add Sibling's Details" v-if="isStudHasSibling === 'Yes'">
              <div style="margin: 0.5rem 0; display: grid; grid-template-columns: auto auto auto auto auto; gap: 2rem; align-items: end">
                <div>
                  <label>Name</label>
                  <input class="form-control" type="text" v-model="studSiblingName" />
                </div>

                <div>
                  <label>Gender</label>
                  <select class="form-control" v-model="studSiblingGender">
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>

                <div>
                  <label>Date of Birth</label>
                  <el-date-picker
                    type="date"
                    v-model="studSiblingDOB"
                    format="dd/MM/yyyy"
                    value-format="dd/MM/yyyy"
                    placeholder="Pick a day"
                    :picker-options="datePicker"
                  />
                </div>

                <div>
                  <label>Present School</label>
                  <input class="form-control" type="text" v-model="studSiblingPresentSch" />
                </div>

                <button @click="addStudSibling()" class="btn common-btn" style="margin-right: auto; color: white; padding: 6px 36px">Add</button>
              </div>

              <div v-if="studArrSiblingDetails.length > 0" style="width: 100%">
                <data-tables :data="studArrSiblingDetails" :action-col="studArrSiblingDetailsListAction">
                  <el-table-column v-for="keyTag in studArrSiblingDetailsList" :prop="keyTag.prop" :label="keyTag.label" :key="keyTag.prop" sortable="custom">
                  </el-table-column>
                </data-tables>
              </div>
            </ApfBasicInput>
          </div>

          <hr />

          <ApfLanguageSection group="MIS" :school="selectOptSchool" :validator="$v" :form="this" />
        </div>

        <div class="saf-parent-guarding-details-container" v-if="currentStep === 1">
          <div>
            <label class="common-label-title">Parent(s) or Local Guardian Details</label>
          </div>

          <div>
            <div class="stud-legal-rights-container">
              <label>Student's Legal Rights</label>
              <p style="font-style: italic">
                Under Singapore law, a person under 21 years of age is considered a minor and the parents/local guardians are responsible for the Student. The
                decision making rights of a minor vest in the parents/local guardians. Where parents of the Student are divorced/separated, the School will
                follow an order of court in the case of dispute to determine the party/parties that has/have custody of the Student and therefore, is
                responsible for making decisions for the Student.
              </p>

              <!--                            <div class="mb-3">-->
              <!--                                <ApfBasicInput name="selectOptParent" class="selectOptParent" disabled-->
              <!--                                               :validator="$v">-->
              <!--                                    <el-select class="w-100" v-model="selectOptParent"-->
              <!--                                               @change="updateOptPrimaryParentArr">-->
              <!--                                        <el-option-->
              <!--                                            v-for="(opt, idx) in arrOptParent"-->
              <!--                                            :key="`arropt-${idx}`"-->
              <!--                                            :label="opt.name"-->
              <!--                                            :value="opt.value">-->
              <!--                                        </el-option>-->
              <!--                                    </el-select>-->
              <!--                                </ApfBasicInput>-->

              <!--                            </div>-->

              <div class="mb-3">
                <label>Primary contact for contracts, billing, school reports, email correspondence, etc.</label>

                <el-select class="w-100" v-model="selectOptPrimaryParent" placeholder="* please choose one of the following">
                  <el-option v-for="(opt, idx) in arrOptPrimaryParent" :key="`arropt-${idx}`" :label="opt.name" :value="opt.value"> </el-option>
                </el-select>
              </div>
            </div>

            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 3rem; align-items: start">
              <div
                style="display: grid; gap: 1.5rem"
                :class="selectOptParent === 'father' ? 'single' : ''"
                v-if="selectOptParent === 'father' || selectOptParent === 'fnm'"
              >
                <div>
                  <label>Father</label>
                  <hr style="margin-bottom: 0" />
                </div>

                <ApfBasicInput name="faFirstName" label="First Name (Given Name)" :validator="$v">
                  <input class="form-control" type="text" v-model="faFirstName" />
                </ApfBasicInput>

                <ApfBasicInput name="faLastName" label="Surname (Family Name)" :validator="$v">
                  <input class="form-control" type="text" v-model="faLastName" />
                </ApfBasicInput>

                <ApfBasicInput label="Middle Name">
                  <input class="form-control" type="text" v-model="faMiddleName" />
                </ApfBasicInput>

                <ApfBasicInput label="Date of Birth">
                  <el-date-picker
                    type="date"
                    v-model="APFP_FatherDob"
                    format="dd/MM/yyyy"
                    value-format="dd/MM/yyyy"
                    placeholder="Pick a day"
                    :picker-options="datePicker"
                  />
                </ApfBasicInput>

                <ApfBasicInput name="faNationality" label="Nationality" :validator="$v">
                  <select class="form-control" v-model="faNationality" style="width: 100%">
                    <option v-for="items in arrCountryList" :key="`FN_${items.CNYid}`" :value="items.CNYnationality.trim()">
                      {{ items.CNYnationality }}
                    </option>
                  </select>
                </ApfBasicInput>

                <ApfBasicInput name="faEmail" label="Email" :validator="$v">
                  <input class="form-control" type="email" v-model="faEmail" />
                </ApfBasicInput>

                <ApfBasicInput name="faTelM" autocomplete="new-password" label="Tel (mobile)" :validator="$v">
                  <AppInputPhoneNumber v-model="faTelM" :validator="$v.faTelM" />
                </ApfBasicInput>

                <ApfBasicInput label="Tel (home)">
                  <AppInputPhoneNumber v-model="faTelH" />
                </ApfBasicInput>

                <MisApfResidencyInputs
                  type="parent"
                  class="col-span-full"
                  :columns="1"
                  :form="this"
                  :validator="$v"
                  :fields="{
                    status: 'faResidencyStatus',
                    number: 'faResidencyDocNo',
                    expiry: 'faResidencyDocExpiry',
                    issueDate: 'faResidencyDocIssueDate',
                  }"
                  group="MIS"
                  @status="faResidencyStatus = $event"
                  @number="faResidencyDocNo = $event"
                  @issueDate="faResidencyDocIssueDate = $event"
                  @expiry="faResidencyDocExpiry = $event"
                />

                <ApfBasicInput label="Company Name">
                  <input class="form-control" type="text" v-model="faCompanyName" />
                </ApfBasicInput>

                <ApfBasicInput label="Occupation">
                  <input class="form-control" type="text" v-model="faOccupation" />
                </ApfBasicInput>
              </div>

              <div
                style="display: grid; gap: 1.5rem"
                :class="selectOptParent === 'mother' ? 'single' : ''"
                v-if="selectOptParent === 'mother' || selectOptParent === 'fnm'"
              >
                <div>
                  <label>Mother</label>
                  <hr style="margin-bottom: 0" />
                </div>

                <ApfBasicInput name="maFirstName" label="First Name (Given Name)" :validator="$v">
                  <input class="form-control" type="text" v-model="maFirstName" />
                </ApfBasicInput>

                <ApfBasicInput name="maLastName" label="Surname (Family Name)" :validator="$v">
                  <input class="form-control" type="text" v-model="maLastName" />
                </ApfBasicInput>

                <ApfBasicInput label="Middle Name">
                  <input class="form-control" type="text" v-model="maMiddleName" />
                </ApfBasicInput>

                <ApfBasicInput label="Date of Birth">
                  <el-date-picker
                    type="date"
                    v-model="APFP_MotherDob"
                    format="dd/MM/yyyy"
                    value-format="dd/MM/yyyy"
                    placeholder="Pick a day"
                    :picker-options="datePicker"
                  />
                </ApfBasicInput>

                <ApfBasicInput name="maNationality" label="Nationality" :validator="$v">
                  <select class="form-control" v-model="maNationality" style="width: 100%">
                    <option v-for="items in arrCountryList" :key="`MN_${items.CNYid}`" :value="items.CNYnationality.trim()">
                      {{ items.CNYnationality }}
                    </option>
                  </select>
                </ApfBasicInput>

                <ApfBasicInput name="maEmail" label="Email" :validator="$v">
                  <input class="form-control" type="email" v-model="maEmail" />
                </ApfBasicInput>

                <ApfBasicInput name="maTelM" label="Tel (mobile)" :validator="$v">
                  <AppInputPhoneNumber v-model="maTelM" :validator="$v.maTelM" />
                </ApfBasicInput>

                <ApfBasicInput label="Tel (home)">
                  <AppInputPhoneNumber v-model="maTelH" />
                </ApfBasicInput>

                <MisApfResidencyInputs
                  type="parent"
                  class="col-span-full"
                  :columns="1"
                  :form="this"
                  :validator="$v"
                  :fields="{
                    status: 'maResidencyStatus',
                    number: 'maResidencyDocNo',
                    expiry: 'maResidencyDocExpiry',
                    issueDate: 'maResidencyDocIssueDate',
                  }"
                  group="MIS"
                  @status="maResidencyStatus = $event"
                  @number="maResidencyDocNo = $event"
                  @issueDate="maResidencyDocIssueDate = $event"
                  @expiry="maResidencyDocExpiry = $event"
                />

                <ApfBasicInput label="Company Name">
                  <input class="form-control" type="text" v-model="maCompanyName" />
                </ApfBasicInput>

                <ApfBasicInput label="Occupation">
                  <input class="form-control" type="text" v-model="maOccupation" />
                </ApfBasicInput>
              </div>
            </div>

            <hr />

            <div class="emergency-contact-container">
              <div class="header-a">
                <strong>Emergency Contact</strong>
              </div>

              <div style="display: grid; grid-template-columns: repeat(4, auto); column-gap: 2rem; margin-bottom: 2rem">
                <div class="col-span-full" style="font-weight: bold">Contact 1 (mandatory)</div>

                <ApfBasicInput name="emgPerson1" label="Name" :validator="$v">
                  <input class="form-control" type="text" v-model="emgPerson1" />
                </ApfBasicInput>

                <ApfBasicInput name="emgRelationship1" label="Relationship to Child" :validator="$v">
                  <input class="form-control" type="text" v-model="emgRelationship1" />
                </ApfBasicInput>

                <ApfBasicInput name="emgTelM1" label="Tel (mobile)" :validator="$v">
                  <AppInputPhoneNumber v-model="emgTelM1" :validator="emgTelM1" />
                </ApfBasicInput>

                <ApfBasicInput label="Tel (home)">
                  <AppInputPhoneNumber v-model="emgTelH1" />
                </ApfBasicInput>

                <div class="col-span-full" style="font-weight: bold; margin-top: 1rem">Contact 2</div>

                <ApfBasicInput label="Name">
                  <input class="form-control" type="text" v-model="emgPerson2" />
                </ApfBasicInput>

                <ApfBasicInput label="Relationship to Child">
                  <input class="form-control" type="text" v-model="emgRelationship2" />
                </ApfBasicInput>

                <ApfBasicInput label="Tel (mobile)">
                  <AppInputPhoneNumber v-model="emgTelM2" />
                </ApfBasicInput>

                <ApfBasicInput label="Tel (home)">
                  <AppInputPhoneNumber v-model="emgTelH2" />
                </ApfBasicInput>
              </div>
            </div>

            <hr />

            <div class="correspondence-container">
              <ApfBasicInput name="corrResidingType" label="Student will be residing with" :validator="$v" style="margin-bottom: 1rem">
                <select class="form-control" v-model="corrResidingType">
                  <option value="father">Father</option>
                  <option value="mother">Mother</option>
                  <option value="parents">Parents</option>
                  <option value="guardian">Guardian</option>
                </select>
              </ApfBasicInput>

              <div
                v-if="corrResidingType === 'guardian'"
                style="
                  display: grid;
                  grid-template-columns: 1fr 1fr;
                  column-gap: 2rem;
                  row-gap: 1rem;
                  border: 1px solid lightgray;
                  padding: 1rem;
                  border-radius: 2px;
                  margin-bottom: 2rem;
                "
              >
                <div style="font-weight: bold; grid-column: 1 / -1"><img src="../../assets/VectorMale.png" /> Guardian</div>
                <ApfBasicInput label="Name">
                  <input class="form-control" type="text" v-model="gdName" />
                </ApfBasicInput>
                <ApfBasicInput label="Email">
                  <input class="form-control" type="text" v-model="gdEmail" />
                </ApfBasicInput>
                <ApfBasicInput label="Tel (mobile)">
                  <AppInputPhoneNumber v-model="gdTelM" />
                </ApfBasicInput>
                <ApfBasicInput label="Tel (home)">
                  <AppInputPhoneNumber v-model="gdTelH" />
                </ApfBasicInput>
              </div>

              <ApfBasicInput name="corrAddress" label="Address in Singapore" style="margin-bottom: 1rem">
                <textarea class="form-control" rows="4" v-model="corrAddress"></textarea>
              </ApfBasicInput>

              <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 2rem">
                <ApfBasicInput name="corrAddressPostal" label="Postal Code">
                  <input class="form-control" type="text" v-model="corrAddressPostal" />
                </ApfBasicInput>

                <ApfBasicInput name="corrAddressCountry" label="Country">
                  <input class="form-control" type="text" v-model="corrAddressCountry" disabled />
                </ApfBasicInput>
              </div>
            </div>
            <hr />

            <div class="billing-details-container" style="display: grid; grid-template-columns: 1fr 1fr; row-gap: 1rem; column-gap: 2rem">
              <div class="header-a col-span-full m-0">
                <strong>Billing Name & Address for Course Fees (if different from the above)</strong>
              </div>

              <ApfBasicInput label="Billing Name" class="col-span-full">
                <input class="form-control" type="text" v-model="billName" />
              </ApfBasicInput>

              <ApfBasicInput label="Address" class="col-span-full">
                <textarea class="form-control" rows="4" v-model="billAddress"></textarea>
              </ApfBasicInput>

              <ApfBasicInput name="billAddressPostal" label="Postal Code">
                <input class="form-control" type="text" v-model="billAddressPostal" />
              </ApfBasicInput>

              <ApfBasicInput name="billAddressCountry" label="Country">
                <select class="form-control w-full" v-model="billAddressCountry">
                  <option v-for="items in arrCountryList" :key="items.CNYid" :value="items.CNYname.trim()">
                    {{ items.CNYname }}
                  </option>
                </select>
              </ApfBasicInput>

              <ApfBasicInput name="billEmail" label="Email">
                <input class="form-control" type="email" v-model="billEmail" />
              </ApfBasicInput>

              <ApfBasicInput label="Tel">
                <input class="form-control" type="text" v-model="billTel" />
              </ApfBasicInput>
            </div>
          </div>
        </div>

        <div class="saf-supportive-information-container" v-if="currentStep === 2">
          <ApfQuestions
            group="MIS"
            title="Supporting Information"
            :school="selectOptSchool"
            :questions="questionAryObj"
            :validator="$v.questionAryObj"
            style="margin-bottom: 1rem"
          />
          <hr />

          <div style="margin-bottom: 30px">
            <label style="color: #212121; font-weight: bold"
              >IMPORTANT: Should Middleton be unable to contact the child’s parent(s) or emergency contact person, I give permission to Middleton to seek
              medical assistance for my child. I will bear full financial responsibility for any cost incurred.</label
            >
          </div>

          <div style="display: grid; grid-template-columns: 1fr 1fr; column-gap: 2rem">
            <div>
              <ApfBasicInput name="siSignatureName" label="Name of Parent / Guardian" :validator="$v" style="margin-bottom: 1rem">
                <input class="form-control" type="text" v-model="siSignatureName" v-on:change="copySignaturenName()" />
              </ApfBasicInput>

              <ApfBasicInput label="* Date">
                <el-date-picker
                  disabled
                  type="date"
                  v-model="siSignatureDate"
                  format="dd/MM/yyyy"
                  value-format="dd/MM/yyyy"
                  placeholder="Pick a day"
                  :picker-options="datePicker"
                />
              </ApfBasicInput>
            </div>

            <ApfBasicInput name="siSignature" label="Signature" :validator="$v">
              <div v-on:click="$bvModal.show('signatureModal')" class="signature-pad">
                <img v-if="siSignature" :src="siSignature" type="file" class="imgParentSignature" />
              </div>
            </ApfBasicInput>
          </div>
        </div>

        <!--        <div class="saf-declration-agreement-container" v-if="currentStep === 3">-->

        <!--        </div>-->

        <div v-if="currentStep === 3" class="saf-declration-agreement-container">
          <label class="common-label-title" style="margin-bottom: 0">Document Checklist for Parents</label>
          <p style="color: #212121">
            To submit more than one document for each field, select the required documents and <strong>upload at the same time</strong>. Only jpg, png and pdf
            files will be accepted and the file size should not be more than 10MB. You may submit your application even if you do not have all the documents.
            However, kindly note that we require all mandatory documents before your applications will be assessed holistically by our Academic Board.
          </p>
          <div :class="{ 'form-group--error': $v.apat_ids.$error }">
            <ApfUploadInput
              :attachments="apat_ids"
              @remove="removeAttachmentID"
              @add="onFileChanged"
              :doc="item.doc"
              v-for="(item, index) in misApfDocumentChecklist"
            >
              <div>
                <strong>{{ index + 1 }}. {{ item.label }} {{ checkAttachIsRequired(item.doc) }}</strong>
                <div
                  class="requiredFieldsMsg"
                  v-if="$v.apat_ids.$error && !$v.apat_ids.hasStuPassport && item.doc === 'doc_stuPassport'"
                  style="margin: 10px 0"
                >
                  <el-alert title="Child’s passport is required" type="error"></el-alert>
                </div>
                <div
                  class="requiredFieldsMsg"
                  v-if="$v.apat_ids.$error && !$v.apat_ids.hasFatherPassport && item.doc === 'doc_faPassport'"
                  style="margin: 10px 0"
                >
                  <el-alert title="Father’s passport is required" type="error"></el-alert>
                </div>
                <div
                  class="requiredFieldsMsg"
                  v-if="$v.apat_ids.$error && !$v.apat_ids.hasMotherPassport && item.doc === 'doc_maPassport'"
                  style="margin: 10px 0"
                >
                  <el-alert title="Mother’s passport is required" type="error"></el-alert>
                </div>
                <div
                  class="requiredFieldsMsg"
                  v-if="$v.apat_ids.$error && !$v.apat_ids.hasStuBirthCert && item.doc === 'doc_stuBirthCert'"
                  style="margin: 10px 0"
                >
                  <el-alert title="Child’s Birth Certificate is required" type="error"></el-alert>
                </div>
                <div
                  class="requiredFieldsMsg"
                  v-if="$v.apat_ids.$error && !$v.apat_ids.hasVaccination && item.doc === 'doc_stuVaccination'"
                  style="margin: 10px 0"
                >
                  <el-alert title="Child’s Vaccination Certificate is required" type="error"></el-alert>
                </div>
              </div>
            </ApfUploadInput>
          </div>
          <div>
            <div><label class="common-label-title">TERMS AND CONDITIONS</label></div>

            <div>
              <ApfDeclarationAndAgreement :validator="$v" group="MIS" style="margin-bottom: 2rem" :withAcknowledgement="true" />

              <div class="row m-0" style="display: grid; grid-template-columns: 1fr 1fr; column-gap: 2rem">
                <div>
                  <div :class="{ 'form-group--error': $v.daSignatureName.$error }">
                    <label>
                      <span>* Name of Parent / Guardian </span>
                      <small v-if="!daSignatureName" style="color: red"><b>Please check at step 3</b></small>
                    </label>
                    <input class="form-control" type="text" v-model="daSignatureName" disabled />
                    <div class="error requiredFieldsMsg" v-if="!$v.daSignatureName.required" style="margin-bottom: 10px">
                      <el-alert title="Name of Parent / Guardian is required." type="error"></el-alert>
                    </div>
                  </div>

                  <div>
                    <label>* Date</label>
                    <el-date-picker
                      disabled
                      type="date"
                      v-model="daSignatureDate"
                      format="dd/MM/yyyy"
                      value-format="dd/MM/yyyy"
                      placeholder="Pick a day"
                      :picker-options="datePicker"
                    />
                  </div>
                </div>

                <div :class="{ 'form-group--error': $v.daSignature.$error }">
                  <label>* Signature </label>
                  <div
                    style="
                      border: 1px solid whitesmoke;
                      height: 120px;
                      width: 100%;
                      background: whitesmoke;
                      border-radius: 6px;
                      cursor: pointer;
                      max-height: 120px;
                      overflow: auto;
                    "
                  >
                    <img v-if="daSignature" :src="daSignature" type="file" style="height: 100%; width: 100%; object-fit: contain" class="imgParentSignature" />
                  </div>
                  <div class="error requiredFieldsMsg" v-if="!$v.daSignature.required" style="margin-bottom: 10px">
                    <el-alert title="Signature is required." type="error"></el-alert>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div><label class="common-label-title">Declaration & Agreements</label></div>

            <div :class="{ 'form-group--error': $v.agreeCounselling.$error }">
              <el-checkbox v-model="agreeCounselling" @change="onAgreementUncheck"
                >I have read and acknowledged my understanding of the
                <a
                  class="declarationLink"
                  href="https://docs.google.com/forms/d/e/1FAIpQLSe9OwyUaXnPwKEyP0FUANrIiQ2bFqzN_My1Uh0pUbU6orzKew/viewform"
                  target="_blank"
                  >Pre Course Counselling information</a
                >
                *
              </el-checkbox>
              <div class="error requiredFieldsMsg" v-if="!$v.agreeCounselling.required" style="margin-bottom: 10px">
                <el-alert title="Please read and acknowledge my understanding of the Pre Course Counselling information." type="error"></el-alert>
              </div>
            </div>
            <div :class="{ 'form-group--error': $v.agreeTerms.$error }">
              <el-checkbox v-model="agreeTerms" @change="onAgreementUncheck"
                >I have read and acknowledged the
                <a class="declarationLink" href="https://kws.etonhouse.com/images/MIS_Terms_and_Conditions_AY_2026_REVISED_VERSION_SWDA.pdf" target="_blank">
                  MIS Terms and Conditions
                </a>
                *
              </el-checkbox>
              <div class="error requiredFieldsMsg" v-if="!$v.agreeTerms.required" style="margin-bottom: 10px">
                <el-alert title="Please read and acknowledge the MIS Terms and Conditions." type="error"></el-alert>
              </div>
            </div>
            <div :class="{ 'form-group--error': $v.agreeDocument.$error }">
              <el-checkbox v-model="agreeDocument" @change="onAgreementUncheck"
                >I am acknowledging that all documents and information provided are certified true *
              </el-checkbox>
              <div class="error requiredFieldsMsg" v-if="!$v.agreeDocument.required" style="margin-bottom: 10px">
                <el-alert title="Please acknowledge that all documents and information provided are certified true." type="error"></el-alert>
              </div>
            </div>
            <div :class="{ 'form-group--error': $v.agreeWaitList.$error }">
              <el-checkbox v-model="agreeWaitList" @change="onAgreementUncheck">
                I have read and acknowledged the
                <a class="declarationLink" href="https://kws.etonhouse.com/images/MIS_Waitlist_Terms_and_Conditions_2026_Final_Version.pdf" target="_blank">
                  waitlist agreement
                </a>
                *
              </el-checkbox>
              <div class="error requiredFieldsMsg" v-if="!$v.agreeWaitList.required" style="margin-bottom: 10px">
                <el-alert title="Please read and acknowledge the waitlist agreement." type="error"></el-alert>
              </div>
            </div>
          </div>
          <!--          <ApfUploadInput :attachments="arrChecklistAttach" :remove="removeChecklistAttach" :add="onFileChanged" doc="doc_10">-->
          <!--            <strong>6. Copy of child’s immigration document </strong>-->
          <!--          </ApfUploadInput>-->

          <!--          <ApfUploadInput :attachments="arrChecklistAttach" :remove="removeChecklistAttach" :add="onFileChanged" doc="doc_7">-->
          <!--            <strong>3. Copy of child’s birth certificate</strong>-->
          <!--            <p style="color: #ef5350;">For Student Pass & FIN cards, please include images of BOTH the front and back of the card.</p>-->
          <!--          </ApfUploadInput>-->

          <!--          <ApfUploadInput :attachments="arrChecklistAttach" :remove="removeChecklistAttach" :add="onFileChanged" doc="doc_14">-->
          <!--            <strong>10. Copy of Child’s vaccination certificate (vaccination against Diphtheria and Measles is compulsory in Singapore.  Vaccination records are required for students under 12 years old) or CDA Certificate</strong>-->
          <!--          </ApfUploadInput>-->

          <!--          <ApfUploadInput :attachments="arrChecklistAttach" :remove="removeChecklistAttach" :add="onFileChanged" doc="doc_8">-->
          <!--            <strong>4. Copy of father's passport</strong>-->
          <!--          </ApfUploadInput>-->

          <!--          <ApfUploadInput :attachments="arrChecklistAttach" :remove="removeChecklistAttach" :add="onFileChanged" doc="doc_8">-->
          <!--            <strong>4. Copy of father's immigration document</strong>-->
          <!--          </ApfUploadInput>-->

          <!--          <ApfUploadInput :attachments="arrChecklistAttach" :remove="removeChecklistAttach" :add="onFileChanged" doc="doc_9">-->
          <!--            <strong>5. Copy of mother’s passport </strong>-->
          <!--          </ApfUploadInput>-->

          <!--          <ApfUploadInput :attachments="arrChecklistAttach" :remove="removeChecklistAttach" :add="onFileChanged" doc="doc_9">-->
          <!--            <strong>5. Copy of mother’s immigration document </strong>-->
          <!--          </ApfUploadInput>-->

          <!--          <ApfUploadInput :attachments="arrChecklistAttach" :remove="removeChecklistAttach" :add="onFileChanged" doc="doc_12">-->
          <!--            <strong>8. Photo of parents/guardian</strong>-->
          <!--          </ApfUploadInput>-->

          <!--          <ApfUploadInput :attachments="arrChecklistAttach" :remove="removeChecklistAttach" :add="onFileChanged" doc="doc_13">-->
          <!--            <strong>9. Copy of child’s last 2 years school reports (translated in English)</strong>-->
          <!--          </ApfUploadInput>-->

          <!--          <ApfUploadInput :attachments="arrChecklistAttach" :remove="removeChecklistAttach" :add="onFileChanged" doc="doc_15">-->
          <!--            <strong>11. Any medical, psychology reports and education evaluation reports (whichever is applicable)</strong>-->
          <!--          </ApfUploadInput>-->
        </div>

        <div v-show="currentStep === 4" style="padding-top: 1rem">
          <ApfReferralChannelSelector group="MIS" style="margin-bottom: 1rem" @change="trafficChannel = $event" :channel="trafficChannel" />

          <strong>2. If you have authorised a representative to assist you with this application, please fill in their information below:</strong>
          <div style="display: grid; grid-template-columns: 1fr 1fr; column-gap: 2rem; margin: 0.5rem 0">
            <div>
              <label>Name</label>
              <input class="form-control" type="text" v-model="raAgentName" />
            </div>
            <div>
              <label>Email</label>
              <input class="form-control" type="text" v-model="raAgentEmail" />
            </div>
            <div>
              <label>Company Name</label>
              <input class="form-control" type="text" v-model="raAgentCompanyName" />
            </div>
            <div>
              <label>Contact Number</label>
              <input class="form-control" type="text" v-model="raAgentTel" />
            </div>
          </div>
        </div>

        <div style="margin: 20px 0 0 0; background: #eeeeee; padding: 10px; display: flex; justify-content: space-between; flex-wrap: wrap">
          <button class="btn btn-success" v-if="currentStep === misSteps.length - 1" @click="validationForm()">Submit Application</button>
          <div style="display: flex; gap: 10px; margin-left: auto">
            <button class="btn btn-primary" v-if="currentStep >= 0 && currentStep < misSteps.length" @click="saveDraft()">Save As Draft</button>
            <button class="btn btn-primary" v-if="currentStep > 0 && currentStep <= misSteps.length - 1" @click="changeStep('prev')">Previous</button>
            <button class="btn btn-primary" v-if="currentStep >= 0 && currentStep < misSteps.length - 1" @click="changeStep('next')">Next</button>
          </div>
        </div>
        <div v-if="validationErrors.length > 0" style="padding: 0.5rem 0">
          <div class="el-alert el-alert--error is-light" style="display: block">
            <div style="font-weight: bold">Please fill in the following required fields:</div>
            <ol class="el-alert__content" style="padding-left: 2rem; padding-bottom: 0">
              <li v-for="[errKey] in validationErrors" :key="errKey">
                {{ getValidationMessageFromKey(errKey) }}
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <ApfAfterSubmitMessage group="MIS" v-else-if="isSubmitted" />
    <ApfAfterSaveDraftMessage group="MIS" v-else-if="isDraft" />
    <ApfSignaturePadModal @save="saveSignature($event)" />
    <ApfEmailVerificationModal @verify="setupDraft($event)" />
  </div>
</template>

<script>
import DataSource from '../../data/datasource'
import { lang } from '../../locale'
import moment from 'moment'
import ApfSelectSchoolDropdown from '@/pages/application/components/ApfSelectSchoolDropdown'
import ApfUploadStudentPhoto from '@/pages/application/components/ApfUploadStudentPhoto'
import ApfBasicInput from '@/pages/application/components/ApfBasicInput'
import { misSteps, getValidationMessageFromKey, misValidations, middletonSchools } from './data.js'
import ApfLanguageSection from '@/pages/application/components/ApfLanguageSection'
import ApfQuestions from '@/pages/application/components/ApfQuestions'
import ApfDeclarationAndAgreement from '@/pages/application/texts/ApfDeclarationAndAgreement'
import ApfUploadInput from '@/pages/application/components/ApfUploadInput'
// import ApfUploadPaymentInfo from "@/pages/application/texts/ApfUploadPaymentInfo";
import ApfReferralChannelSelector from '@/pages/application/components/ApfReferralChannelSelector'
import ApfAfterSubmitMessage from '@/pages/application/texts/ApfAfterSubmitMessage'
import ApfAfterSaveDraftMessage from '@/pages/application/texts/ApfAfterSaveDraftMessage'
import ApfSignaturePadModal from '@/pages/application/components/ApfSignaturePadModal'
import ApfEmailVerificationModal from '@/pages/application/components/ApfEmailVerificationModal'
import { misApfDocumentChecklist, requiredMisApfDocumentChecklist } from '@/pages/application/const/applicationConst'
import MisApfResidencyInputs from '@/pages/application/components/residencyInputs/misApfResidencyInputs'
import AppInputPhoneNumber from '@/components/AppInputPhoneNumber.vue'

export default {
  validations: misValidations,
  name: 'MISStudentApplicationForm',
  components: {
    MisApfResidencyInputs,
    ApfEmailVerificationModal,
    ApfSignaturePadModal,
    ApfAfterSaveDraftMessage,
    ApfAfterSubmitMessage,
    ApfReferralChannelSelector,
    // ApfUploadPaymentInfo,
    ApfUploadInput,
    ApfDeclarationAndAgreement,
    ApfQuestions,
    ApfLanguageSection,
    ApfBasicInput,
    ApfUploadStudentPhoto,
    ApfSelectSchoolDropdown,
    AppInputPhoneNumber,
  },
  data() {
    return {
      misSteps,
      currentStep: 0,
      selectOptSchool: null,
      arrCountryList: [],
      currentAPFPID: '',
      allUploadFiles: [],
      uploadedStuImg: [],
      existingApfId: '',
      studProfilePic: '',
      studCommencementDate: '',
      studYearLevel: '',
      studFirstName: '',
      studLastName: '',
      studDOB: '',
      studGender: '',
      studCOB: '',
      studNationality: '',
      studDualCitizenship: '',
      studCurrentYearLevel: '',
      studCurrentSchName: '',
      studCurrentSchCountry: '',
      studIsEnrolled: '',
      studPrevEhSchool: '',
      studPrevEhSchoolYear: '',
      studImmigrationStatus: '',
      studImmigrationStatusNo: '',
      studImmigrationStatusNoExpiryDate: '',
      studImmigrationStatusNoIssueDate: '',
      studFirstLanguage: '',
      studSecondLanguage: '',
      studLanguage: '',
      studArrLanguage: [],
      studArrLanguageList: [{ prop: 'studLang', label: 'Language' }],
      studArrLanguageListAction: {
        label: 'Delete',
        props: { align: 'center' },
        buttons: [
          {
            props: { type: 'primary', icon: 'el-icon-edit' },
            handler: row => {
              this.studArrLanguage.splice(this.studArrLanguage.indexOf(row), 1)
            },
            label: 'Delete',
          },
        ],
      },
      studSiblingName: '',
      studSiblingGender: '',
      studSiblingDOB: '',
      studSiblingPresentSch: '',
      studArrSiblingDetails: [],
      studArrSiblingDetailsList: [
        { prop: 'APS_Name', label: 'Name' },
        { prop: 'APS_Gender', label: 'Gender' },
        { prop: 'APS_DOB', label: 'Date of Birth' },
        { prop: 'APS_PresentSchool', label: 'Present School' },
      ],
      studArrSiblingDetailsListAction: {
        label: 'Delete',
        props: { align: 'center' },
        buttons: [
          {
            props: { type: 'primary', icon: 'el-icon-edit' },
            handler: row => {
              this.studArrSiblingDetails.splice(this.studArrSiblingDetails.indexOf(row), 1)
            },
            label: 'Delete',
          },
        ],
      },
      selectOptParent: 'fnm',
      selectOptPrimaryParent: '',
      arrOptParent: [
        { name: 'Father', value: 'father' },
        { name: 'Mother', value: 'mother' },
        { name: 'Father & Mother', value: 'fnm' },
      ],
      arrOptPrimaryParent: [
        { name: 'Father', value: 'father' },
        { name: 'Mother', value: 'mother' },
      ],
      imageUrl: '',
      faFirstName: '',
      faLastName: '',
      faMiddleName: '',
      APFP_FatherDob: '',
      faNationality: '',
      faEmail: '',
      faTelM: '',
      faTelH: '',
      faResidencyStatus: '',
      faResidencyDocNo: '',
      faResidencyDocExpiry: '',
      faResidencyDocIssueDate: '',
      faCompanyName: '',
      faOccupation: '',
      maFirstName: '',
      maLastName: '',
      maMiddleName: '',
      APFP_MotherDob: '',
      maNationality: '',
      maEmail: '',
      maTelM: '',
      maTelH: '',
      maResidencyStatus: '',
      maResidencyDocNo: '',
      maResidencyDocExpiry: '',
      maResidencyDocIssueDate: '',
      maCompanyName: '',
      maOccupation: '',
      gdName: '',
      gdEmail: '',
      gdTelM: '',
      gdTelH: '',
      emgPerson1: '',
      emgRelationship1: '',
      emgTelM1: '',
      emgTelH1: '',
      emgPerson2: '',
      emgRelationship2: '',
      emgTelM2: '',
      emgTelH2: '',
      corrResidingType: '',
      corrAddress: '',
      corrAddressPostal: '',
      corrAddressCountry: 'Singapore',
      billName: '',
      billAddress: '',
      billAddressPostal: '',
      billAddressCountry: 'Singapore',
      billEmail: '',
      billTel: '',
      siSignatureName: '',
      siSignature: '',
      siSignatureDate: '',
      daSignatureName: '',
      daSignature: '',
      daSignatureDate: '',
      daSignatureAPATID: '',
      siSignatureAPATID: '',
      currentStudentImgPreview: '',
      currentStudentImageAPATID: '',
      raAgentName: '',
      raAgentEmail: '',
      raAgentTel: '',
      raAgentCompanyName: '',
      trafficChannel: '',
      arrChecklistAttach: [],
      arrChecklistPrevAttach: [],
      signatureType: '',
      questionAryObj: [],
      schoolNameList: [],
      isSubmitted: false,
      isDraft: false,
      inputFirstCommencementDate: '',
      autoLevel: '',
      isStudHasSibling: 'No',
      studISDoc: [],
      apat_ids: [],
      apatList: [],
      InternationalSchoolNameList: '',
      bilingualYesNoValue: '',
      additionalLangValue: '',
      englishReading: '',
      englishWriting: '',
      englishSpeaking: '',
      passportNumber: '',
      passportExpiryDate: '',
      studentPassExpiryDate: '',
      studentPassIssueDate: '',
      datePicker: {
        disabledDate(date) {
          return date > new Date().getTime()
        },
      },
      CommDatePicker: {
        disabledDate(time) {
          return time.getDay() === 0 || time.getDay() === 6
        },
      },
      agreeCounselling: null,
      agreeTerms: null,
      agreeTerms2: null,
      agreeWaitList: null,
      agreeDocument: null,
      misApfDocumentChecklist: misApfDocumentChecklist,
      termsAccordion: ['1'],
      showForm: false,
    }
  },
  props: [],
  watch: {
    selectOptSchool: 'handleShowForm',
    agreeTerms2: 'handleShowForm',
  },
  async mounted() {
    window.pageApp = this
    window.document.title = 'Middleton Application Form'
    if (this.$route.query.ID) {
      this.$bvModal.show('emailVerificationModal')
    } else {
      await this.getTodayDate()
      await this.BindCountryList()
      await this.BindQuestion()
      await this.BindSchoolDropdown()
    }
  },
  methods: {
    lang,
    handleShowForm(value) {
      if (value) {
        this.$v.agreeTerms2.$touch()
        this.showForm = !this.$v.agreeTerms2.$error
      }
    },
    getURLBase() {
      return process.env.VUE_APP_ROOT_API
    },
    getValidationMessageFromKey,
    onSelection(event) {
      const data = event.target.value
      this.studImmigrationStatus = data === 'yes' ? 'STPIP(Student Pass In Progress)' : ''
    },
    updateOptPrimaryParentArr() {
      switch (this.selectOptParent) {
        case 'father':
          this.arrOptPrimaryParent = [{ name: 'Father', value: 'father' }]
          break
        case 'mother':
          this.arrOptPrimaryParent = [{ name: 'Mother', value: 'mother' }]
          break
        default:
          this.arrOptPrimaryParent = [
            { name: 'Father', value: 'father' },
            { name: 'Mother', value: 'mother' },
          ]
          break
      }
    },
    onAgreementUncheck() {
      if (this.agreeWaitList === false) {
        this.agreeWaitList = null
      }
      if (this.agreeCounselling === false) {
        this.agreeCounselling = null
      }
      if (this.agreeTerms === false) {
        this.agreeTerms = null
      }
      if (this.agreeDocument === false) {
        this.agreeDocument = null
      }
      if (this.agreeTerms2 === false) {
        this.agreeTerms2 = null
      }
      if (this.agreeTerms2) {
        this.termsAccordion = []
      }
    },
    onResidencyChange() {
      if (!this.faResidencyStatus) {
        this.faResidencyStatus = this.studImmigrationStatus
      }
      if (!this.maResidencyStatus) {
        this.maResidencyStatus = this.studImmigrationStatus
      }
    },
    async getDraftApplicationForm(appId) {
      const resp = await DataSource.shared.getDraftApplicationForm(appId)
      if (resp?.code === '99') {
        return this.flashError('Failed to retrieve draft application.')
      }
      resp.FormTable.forEach(m => {
        this.selectOptSchool = m.APF_ApplicationSchool
        this.currentAPFPID = m.APFP_ID
        const fatherEmail = m.APFP_FatherPersonalEmail ?? ''
        const motherEmail = m.APFP_MotherPersonalEmail ?? ''
        if (fatherEmail !== '' && motherEmail !== '') {
          this.selectOptParent = 'fnm'
          this.faEmail = m.APFP_FatherPersonalEmail
          this.maEmail = m.APFP_MotherPersonalEmail
        } else if (fatherEmail !== '') {
          this.selectOptParent = 'father'
          this.faEmail = m.APFP_FatherPersonalEmail
        } else if (motherEmail !== '') {
          this.selectOptParent = 'mother'
          this.maEmail = m.APFP_MotherPersonalEmail
        }
        this.studFirstName = m.APF_FirstName ?? ''
        this.studLastName = m.APF_Surname ?? ''
        this.studDOB = m.APF_DOB ?? ''
        this.studCOB = m.APF_POB ?? ''
        this.studCurrentSchName = m.APF_CurrentSchool ?? ''
        this.studCurrentSchCountry = m.APF_CurrentCountry ?? ''
        this.inputFirstCommencementDate = m.APF_CommencementDate?.substring(0, 10) ?? ''
        this.studImmigrationStatus = m.APF_IDType ?? ''
        this.studImmigrationStatusNo = m.APF_IDNumber ?? ''
        this.studGender = m.APF_Gender ?? ''
        this.corrAddressSingapore = m.APF_HomeAddress ?? ''
        this.studNationality = m.APF_Nationality ?? ''
        this.studIsEnrolled = m.APF_EnrolPreviously ?? ''
        this.studPrevEhSchool = m.APF_EnrolPreviouslySchool ?? ''
        this.studImmigrationStatusNoExpiryDate = m.APF_IDPASSExpiredDate?.substring(0, 10) ?? ''
        this.studImmigrationStatusNoIssueDate = m.APF_IDPASSIssueDate?.substring(0, 10) ?? ''
        this.studFirstLanguage = m.APF_1stLang ?? ''
        this.studSecondLanguage = m.APF_2ndLang ?? ''
        this.emgPerson1 = m.APF_Emer1Name ?? ''
        this.emgRelationship1 = m.APF_Emer1Relation ?? ''
        this.emgTelM1 = m.APF_Emer1Mobile ?? ''
        this.emgTelH1 = m.APF_Emer1Tel ?? ''
        this.emgPerson2 = m.APF_Emer2Name ?? ''
        this.emgRelationship2 = m.APF_Emer2Relation ?? ''
        this.emgTelM2 = m.APF_Emer2Mobile ?? ''
        this.emgTelH2 = m.APF_Emer2Tel ?? ''
        this.corrResidingType = m.APF_CorrResidingWith ?? ''
        this.corrAddress = m.APF_CorrAddress ?? ''
        this.corrAddressPostal = m.APF_CorrPostal ?? ''
        this.corrAddressCountry = m.APF_CorrCountry ?? ''
        this.billName = m.APF_BillingName ?? ''
        this.billAddress = m.APF_BillingAddress ?? ''
        this.billAddressPostal = m.APF_BillingPostal ?? ''
        this.billAddressCountry = m.APF_BillingCountry ?? ''
        this.billEmail = m.APF_BillingEmail ?? ''
        this.billAddress = m.APF_BillingAddress ?? ''
        this.billTel = m.APF_BillingTel ?? ''
        this.raAgentName = m.APF_ReferralAgentName ?? ''
        this.raAgentEmail = m.APF_ReferralAgentEmail ?? ''
        this.raAgentTel = m.APF_ReferralAgentTel ?? ''
        this.raAgentCompanyName = m.APF_ReferralCompany ?? ''
        this.bilingualYesNoValue = m.APF_BilingualProgram ?? ''
        this.additionalLangValue = m.APF_AdditionalLanguage ?? ''
        this.trafficChannel = m.APF_TrafficChannel ?? ''
        this.studDualCitizenship = m.APF_DualCitizenship ?? ''
        this.studPrevEhSchoolYear = m.APF_EnrolPreviouslySchoolYear ?? ''
        this.englishReading = m.APF_EnglishReadingProficiency ?? ''
        this.englishWriting = m.APF_EnglishWritingProficiency ?? ''
        this.englishSpeaking = m.APF_EnglishSpeakingProficiency ?? ''
        this.passportNumber = m.APF_PassportNumber ?? ''
        this.passportExpiryDate = m.APF_PassportExpiryDate?.substring(0, 10) ?? ''
        this.faFirstName = m.APFP_FatherFirstName ?? ''
        this.faLastName = m.APFP_FatherLastName ?? ''
        this.faNationality = m.APFP_FatherNationality ?? ''
        this.faOccupation = m.APFP_FatherOccupation ?? ''
        this.faCompanyName = m.APFP_FatherCompanyName ?? ''
        this.faTelM = m.APFP_FatherMobile ?? ''
        this.faTelH = m.APFP_FatherHomeTel ?? ''
        this.faEmail = m.APFP_FatherPersonalEmail ?? ''
        this.faMiddleName = m.APFP_FatherMiddleName ?? ''
        this.APFP_FatherDob = m.APFP_FatherDob?.substring(0, 10) ?? ''
        this.faResidencyStatus = m.APFP_FatherResidencyStatus ?? ''
        this.faResidencyDocNo = m.APFP_FatherResidencyDocNo ?? ''
        this.faResidencyDocExpiry = m.APFP_FatherResidencyDocExpiry?.substring(0, 10) ?? ''
        this.faResidencyDocIssueDate = m.APFP_FatherResidencyDocIssueDate?.substring(0, 10) ?? ''
        this.maFirstName = m.APFP_MotherFirstName ?? ''
        this.maLastName = m.APFP_MotherLastName ?? ''
        this.maNationality = m.APFP_MotherNationality ?? ''
        this.maOccupation = m.APFP_MotherOccupation ?? ''
        this.maCompanyName = m.APFP_MotherCompanyName ?? ''
        this.maTelM = m.APFP_MotherMobile ?? ''
        this.maTelH = m.APFP_MotherHomeTel ?? ''
        this.maEmail = m.APFP_MotherPersonalEmail ?? ''
        this.maMiddleName = m.APFP_MotherMiddleName ?? ''
        this.APFP_MotherDob = m.APFP_MotherDob?.substring(0, 10) ?? ''
        this.maResidencyStatus = m.APFP_MotherResidencyStatus ?? ''
        this.maResidencyDocNo = m.APFP_MotherResidencyDocNo ?? ''
        this.maResidencyDocExpiry = m.APFP_MotherResidencyDocExpiry?.substring(0, 10) ?? ''
        this.maResidencyDocIssueDate = m.APFP_MotherResidencyDocIssueDate?.substring(0, 10) ?? ''
        this.gdName = m.APFP_LegalGuardianName ?? ''
        this.gdEmail = m.APFP_LegalGuardianEmail ?? ''
        this.gdTelM = m.APFP_LegalGuardianMobile ?? ''
        this.gdTelH = m.APFP_LegalGuardianHomeTel ?? ''
        this.studArrSiblingDetails = resp.SiblingTable
        this.isStudHasSibling = resp.SiblingTable.length > 0 ? 'Yes' : 'No'

        const attachTableList = resp.AttachTable
        attachTableList.forEach(n => {
          if (n.APAT_UploadType === 'stuIMG') {
            this.currentStudentImgPreview = n.APAT_FilePath + n.APAT_EnrolFileName + n.APAT_EnrolFileExt
            this.currentStudentImageAPATID = n.APAT_ID
            this.uploadedStuImg = n.APAT_FilePath + n.APAT_EnrolFileName + n.APAT_EnrolFileExt
          }
          if (n.APAT_UploadType === 'Declare & Agreement') {
            this.daSignature = n.APAT_FilePath + n.APAT_EnrolFileName + n.APAT_EnrolFileExt
            this.daSignatureAPATID = n.APAT_ID
            this.daSignatureName = n.APAT_SignatureName
          }
          if (n.APAT_UploadType === 'Supporting Information') {
            this.siSignature = n.APAT_FilePath + n.APAT_EnrolFileName + n.APAT_EnrolFileExt
            this.siSignatureAPATID = n.APAT_ID
            this.siSignatureName = n.APAT_SignatureName
          }
          const uploadTypes = ['stuIMG', 'Declare & Agreement', 'Supporting Information', 'studISDoc']
          if (n.APAT_UploadType === 'studISDoc' || !uploadTypes.includes(n.APAT_UploadType)) {
            n.attType = n.APAT_UploadType
            n.attFile = new Array({ data: {} })
            n.attFile.forEach(f => {
              f.apat_id = n.APAT_ID
              f.attType = n.APAT_UploadType
              f.name = n.APAT_EnrolFileName
              f.url = n.APAT_FilePath + n.APAT_EnrolFileName + n.APAT_EnrolFileExt
              n.attFile.push(f)
            })
            n.attFile = [...new Set(n.attFile)]
            if (n.APAT_UploadType === 'studISDoc') this.studISDoc.push(n)
            else this.apat_ids.push(n)
            this.arrChecklistPrevAttach.push(n)
            this.arrChecklistPrevAttach.push(n)
          }
        })
      })
      const AnswerTableList = resp.AnswerTable
      this.questionAryObj.forEach(f => {
        AnswerTableList.forEach(m => {
          if (f.APFQ_ID === m.APFQ_ID) {
            f.newAnswer = m.APFA_Answer
            f.newAnswerValue = m.APFA_AnswerValue
            f.newAnswerValue1 = m.APFA_AnswerValue1
            f.newAnswerValue2 = m.APFA_AnswerValue2
            return false
          }
        })
      })
    },

    getTodayDate() {
      const currentDate =
        new Date().getFullYear() + '-' + String(new Date().getMonth() + 1).padStart(2, '0') + '-' + String(new Date().getDate()).padStart(2, '0')
      this.siSignatureDate = currentDate
      this.daSignatureDate = currentDate
    },

    clickStep(index) {
      this.currentStep = index
    },

    changeStep(type) {
      if (type === 'prev') {
        this.currentStep = this.currentStep - 1
      } else {
        if (this.currentStep === 3) {
          if (this.validateDeclarationOnNext()) {
            this.currentStep = this.currentStep + 1
            window.scrollTo(0, 0)
          }
        } else {
          this.currentStep = this.currentStep + 1
          window.scrollTo(0, 0)
        }
      }
    },

    validateDeclarationOnNext() {
      this.$v.agreeCounselling.$touch()
      this.$v.agreeTerms.$touch()
      this.$v.agreeDocument.$touch()
      this.$v.agreeWaitList.$touch()
      return !this.$v.agreeCounselling.$error && !this.$v.agreeTerms.$error && !this.$v.agreeDocument.$error && !this.$v.agreeWaitList.$error
    },

    addStudSibling() {
      if (!this.studSiblingName) return this.flashError('Please fill in sibling name.')
      if (!this.studSiblingGender) return this.flashError('Please select sibling gender.')
      if (!this.studSiblingDOB) return this.flashError('Please select sibling date of birth.')
      this.studArrSiblingDetails.push({
        APS_Name: this.studSiblingName,
        APS_Gender: this.studSiblingGender,
        APS_DOB: this.studSiblingDOB,
        APS_PresentSchool: this.studSiblingPresentSch,
      })
      this.studSiblingName = ''
      this.studSiblingGender = ''
      this.studSiblingDOB = ''
      this.studSiblingPresentSch = ''
    },

    async onFileChanged(event, attType) {
      const files = event.target?.files ?? event
      if (files.length > 0) {
        let eachObjAttachment = {}
        eachObjAttachment.attType = attType
        this.arr_SelectedFileList = []
        let isUploadFile = true
        for await (let file of files) {
          let fileSize = file.size / 1024 / 1024
          if (fileSize > 10) {
            isUploadFile = false
            this.$notify.error({
              title: 'Error',
              message: 'File limit exceeded 10MB',
            })
          }
        }
        if (isUploadFile) {
          for await (let file of files) {
            file.url = URL.createObjectURL(file)
          }
          eachObjAttachment.attFile = files
        }
        // Note: Upload file asynchronously using this API to prevent form submission delay
        await this.checkAttachmentID(eachObjAttachment)
        await this.saveApplicationAttachment(eachObjAttachment)

        if (attType === 'stuIMG') {
          this.uploadedStuImg = event
        }
        // if (attType === 'studISDoc') this.studISDoc.push(eachObjAttachment);
        // else this.arrChecklistAttach.push(eachObjAttachment);
      }
    },

    async saveApplicationAttachment(eachObjAttachment) {
      if (eachObjAttachment?.attFile?.length > 0) {
        try {
          const response = await DataSource.shared.saveApplicationAttachment(eachObjAttachment.attFile, eachObjAttachment.attType)
          if (response) {
            if (response?.length !== eachObjAttachment.attFile?.length) {
              this.flashError('Unknown Error! Please contact support.')
            } else {
              let newUpload = response?.map(d => {
                d.attType = eachObjAttachment.attType
                return d
              })
              this.apat_ids.push(...newUpload)
            }
          }
        } catch (e) {
          console.log(e)
        }
      }
    },

    checkAttachmentID(objAttach) {
      this.apat_ids.forEach(att => {
        if (att.attType === objAttach.attType) {
          this.apat_ids.splice(this.apat_ids.indexOf(att), 1)
        }
      })
    },

    async removeAttachmentID(objAttach) {
      this.apat_ids = this.apat_ids?.filter(d => d.APAT_ID !== objAttach.APAT_ID)
    },

    // checkAttachment(objAttach) {
    //     this.arrChecklistAttach.forEach(att => {
    //         if (att.attType === objAttach.attType) {
    //             this.arrChecklistAttach.splice(this.arrChecklistAttach.indexOf(att), 1);
    //         }
    //     });
    // },

    async BindQuestion() {
      const resp = await DataSource.shared.getApplicationQuestion()
      let assignedList = []
      resp.Table.forEach(m => {
        if (m?.APFQ_ID === 'ENFQ202000000443') {
          m.APFQ_Desc =
            "Does your child have any learning / behavioural / social difficulties? Or receives any specific therapy or support? Please give details of any relevant information and attach all psychoeducational, developmental or special education evaluation reports of any assessments carried out by your child's previous school(s) or external specialist agencies in the documents submission section."
        }
        let tempList = {
          newAnswer: m.newAnswer,
          newAnswerValue: m.newAnswerValue,
          newAnswerValue1: m.newAnswerValue1,
          newAnswerValue2: m.newAnswerValue2,
          APFQ_Desc: m.APFQ_Desc,
          APFQ_ID: m.APFQ_ID,
          APFQ_Ordering: m.APFQ_Ordering,
          APFQ_Status: m.APFQ_Status,
          APFQ_Type: m.APFQ_Type,
        }
        assignedList.push(tempList)
      })
      this.questionAryObj = assignedList
    },

    async BindCountryList() {
      try {
        await this.$vs.loading()
        const response = await DataSource.shared.getCountryListWithoutToken()
        this.arrCountryList = response.Table
      } finally {
        await this.$vs.loading.close()
      }
    },

    async saveApplicationForm(asDraft = false) {
      await this.$vs.loading()
      try {
        this.questionAryObj?.forEach(d => {
          if (['ENFQ202000000443', 'ENFQ202000000997'].includes(d.APFQ_ID)) {
            if (d.newAnswer === 'yes') {
              d.newAnswer = d.newAnswerValue
            }
          }
        })

        let studObj = {
          APF_Surname: this.studLastName,
          APF_FirstName: this.studFirstName,
          APF_DOB: this.studDOB,
          APF_POB: this.studCOB,
          APF_CommencementDate: this.inputFirstCommencementDate,
          APF_IDType: this.studImmigrationStatus,
          APF_IDNumber: this.studImmigrationStatusNo,
          APF_Gender: this.studGender,
          APF_HomeAddress: this.corrAddressSingapore,
          APF_Nationality: this.studNationality,
          APF_CurrentSchool: this.studCurrentSchName,
          APF_CurrentCountry: 'Singapore',
          APF_EnrolPreviously: this.studIsEnrolled,
          APF_EnrolPreviouslySchool: this.studPrevEhSchool,
          APF_IDPASSExpiredDate: this.studImmigrationStatusNoExpiryDate,
          APF_IDPASSIssueDate: this.studImmigrationStatusNoIssueDate,
          APF_1stLang: this.studFirstLanguage,
          APF_2ndLang: this.studSecondLanguage,
          APF_Emer1Name: this.emgPerson1,
          APF_Emer1Relation: this.emgRelationship1,
          APF_Emer1Tel: this.emgTelH1,
          APF_Emer1Mobile: this.emgTelM1,
          APF_Emer2Name: this.emgPerson2,
          APF_Emer2Relation: this.emgRelationship2,
          APF_Emer2Tel: this.emgTelH2,
          APF_Emer2Mobile: this.emgTelM2,
          APF_CorrResidingWith: this.corrResidingType,
          APF_CorrAddress: this.corrAddress,
          APF_CorrPostal: this.corrAddressPostal,
          APF_CorrCountry: this.corrAddressCountry,
          APF_BillingName: this.billName,
          APF_BillingAddress: this.billAddress,
          APF_BillingPostal: this.billAddressPostal,
          APF_BillingCountry: this.billAddressCountry,
          APF_BillingEmail: this.billEmail,
          APF_BillingTel: this.billTel,
          APF_ReferralAgentName: this.raAgentName,
          APF_ReferralAgentEmail: this.raAgentEmail,
          APF_ReferralAgentTel: this.raAgentTel,
          APF_ReferralCompany: this.raAgentCompanyName,
          APF_BilingualProgram: this.bilingualYesNoValue,
          APF_AdditionalLanguage: this.additionalLangValue,
          APF_TrafficChannel: this.trafficChannel,
          APF_DualCitizenship: this.studDualCitizenship,
          APF_EnrolPreviouslySchoolYear: this.studPrevEhSchoolYear,
          APF_EnglishReadingProficiency: this.englishReading,
          APF_EnglishWritingProficiency: this.englishWriting,
          APF_EnglishSpeakingProficiency: this.englishSpeaking,
          APF_PassportNumber: this.passportNumber,
          APF_PassportExpiryDate: this.passportExpiryDate,
        }

        let parentObj = {
          APFP_FatherFirstName: this.faFirstName,
          APFP_FatherLastName: this.faLastName,
          APFP_FatherNationality: this.faNationality,
          APFP_FatherResidencyStatus: this.faResidencyStatus,
          APFP_FatherResidencyDocNo: this.faResidencyDocNo,
          APFP_FatherResidencyDocExpiry: this.faResidencyDocExpiry,
          APFP_FatherResidencyDocIssueDate: this.faResidencyDocIssueDate,
          APFP_FatherOccupation: this.faOccupation,
          APFP_FatherCompanyName: this.faCompanyName,
          APFP_FatherMobile: this.faTelM,
          APFP_FatherHomeTel: this.faTelH,
          APFP_FatherPersonalEmail: this.faEmail,
          APFP_FatherMiddleName: this.faMiddleName,
          APFP_FatherDob: this.APFP_FatherDob,
          APFP_MotherFirstName: this.maFirstName,
          APFP_MotherLastName: this.maLastName,
          APFP_MotherNationality: this.maNationality,
          APFP_MotherResidencyStatus: this.maResidencyStatus,
          APFP_MotherResidencyDocNo: this.maResidencyDocNo,
          APFP_MotherResidencyDocExpiry: this.maResidencyDocExpiry,
          APFP_MotherResidencyDocIssueDate: this.maResidencyDocIssueDate,
          APFP_MotherOccupation: this.maOccupation,
          APFP_MotherCompanyName: this.maCompanyName,
          APFP_MotherMobile: this.maTelM,
          APFP_MotherHomeTel: this.maTelH,
          APFP_MotherPersonalEmail: this.maEmail,
          APFP_MotherMiddleName: this.maMiddleName,
          APFP_MotherDob: this.APFP_MotherDob,
          APFP_LegalGuardianName: this.gdName,
          APFP_LegalGuardianEmail: this.gdEmail,
          APFP_LegalGuardianMobile: this.gdTelM,
          APFP_LegalGuardianHomeTel: this.gdTelH,
          APFP_PrimaryParent: this.selectOptPrimaryParent,
        }

        let arrDeclare = []

        if (this.siSignature !== '') {
          let declareObj = {
            SignatureName: this.siSignatureName,
            Signature: this.siSignature,
            SignatureType: 'Supporting Information',
            SignatureAPATID: this.siSignatureAPATID,
          }
          arrDeclare.push(declareObj)
        }

        if (this.daSignature !== '') {
          let declareObj = {
            SignatureName: this.daSignatureName,
            Signature: this.daSignature,
            SignatureType: 'Declare & Agreement',
            SignatureAPATID: this.daSignatureAPATID,
          }
          arrDeclare.push(declareObj)
        }

        // if (this.uploadedStuImg.length > 0) {
        //     this.allUploadFiles.push(this.uploadedStuImg[0]);
        // }
        //
        // if (this.studISDoc.length > 0) {
        //     this.studISDoc.forEach(cFile => {
        //         if (cFile.attFile.length > 0) {
        //             cFile.attFile.forEach(aFile => {
        //                 aFile.uploadType = cFile.attType;
        //                 this.allUploadFiles.push(aFile);
        //             });
        //         }
        //     });
        //     this.allUploadFiles = [...new Set(this.allUploadFiles)];
        //     this.studISDoc.push(this.allUploadFiles);
        // }
        // if (this.arrChecklistAttach.length > 0) {
        //     this.arrChecklistAttach.forEach(cFile => {
        //         if (cFile.attFile.length > 0) {
        //             cFile.attFile.forEach(aFile => {
        //                 aFile.uploadType = cFile.attType;
        //                 this.allUploadFiles.push(aFile);
        //             });
        //         }
        //     });
        //     this.allUploadFiles = [...new Set(this.allUploadFiles)];
        //     this.arrChecklistAttach.push(this.allUploadFiles);
        // }
        const apat_idList = this.apat_ids?.map(d => d.APAT_ID).join(',')

        const res = await DataSource.shared.saveApplicationForm(
          asDraft ? 'Draft' : 'Pending',
          JSON.stringify(this.arrChecklistPrevAttach),
          null,
          JSON.stringify(studObj),
          JSON.stringify(parentObj),
          JSON.stringify(this.questionAryObj),
          JSON.stringify(this.studArrSiblingDetails),
          JSON.stringify(arrDeclare),
          this.selectOptSchool,
          this.existingApfId,
          this.currentAPFPID,
          this.currentStudentImageAPATID,
          apat_idList
        )
        const code = Number(res?.code || 0)
        if (code !== 1) {
          this.flashError(res?.message || 'Unknown Error! Please contact support.')
        }
        this.$notify({
          title: 'Success',
          message: 'Records Successfully Saved',
          type: 'success',
        })
        if (asDraft) this.isDraft = true
        else this.isSubmitted = true
      } finally {
        this.$vs.loading.close()
      }
    },

    async validationForm() {
      this.$v.$touch()
      if (this.$v.$error) {
        return this.flashError('Please fill in all * fields')
      }
      window.scrollTo(0, 0)
      await this.saveApplicationForm()
    },

    async BindSchoolDropdown() {
      try {
        await this.$vs.loading()
        const response = await DataSource.shared.getSchoolDropdownList('UTY201300000061') // UTY201300000061
        if (response && response.code !== '88') {
          this.schoolNameList = response.Table.filter(
            n =>
              !['SCH201400000028', 'SCH201400000037', 'SCH202000000565', 'SCH202100000566', 'SCH202100000567', 'SCH201700000404', 'SCH20120000001'].includes(
                n.SchoolID
              )
          ).map(n => {
            if (['SCH201400000480', 'SCH201400000510', 'SCH201400000553'].includes(n.SchoolID)) n.SchoolName = n.SchoolName.replace('M', 'Mountbatten ')
            return n
          })
        }
      } finally {
        await this.$vs.loading.close()
      }
    },

    async saveSignature(data) {
      this.signatureType = 'si'
      this.siSignature = data
      this.daSignature = data
    },

    checkStudentAge() {
      let bDay = ''
      let convertedBday = ''
      if (!this.studDOB) {
      } else {
        let splittedDate = this.studDOB.split('-')
        bDay = [splittedDate[1], splittedDate[2], splittedDate[0]].join('/')
        convertedBday = bDay.substring(2)
      }
      convertedBday = moment(this.studDOB, 'DD/MM/YYYY').format('DD/MM/YYYY')
      this.getAutoAssignLevelAcademicYear(convertedBday)
    },

    async getAutoAssignLevelAcademicYear(formatterDateVal) {
      const convertCommencementDate = moment(this.inputFirstCommencementDate, 'DD/MM/YYYY').format('DD/MM/YYYY')
      if (formatterDateVal) {
        const response = await DataSource.shared.getAutoAssignLevelAcademicYear(convertCommencementDate, formatterDateVal, this.selectOptSchool)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.autoLevel = response.Table[0].level
          }
        }
      } else {
        this.autoLevel = ''
      }
    },

    async copySignaturenName() {
      this.daSignatureName = this.siSignatureName
    },

    async removeChecklistAttach(objAttach, attType) {
      this.arrChecklistAttach.forEach(att => {
        if (att.attType === attType && att.attFile.length > 0) {
          const newFileList = Array.from(att.attFile)
          for (let a = 0; a < att.attFile.length; a++) {
            if (att.attFile[a].name === objAttach.name) {
              newFileList.splice(newFileList.indexOf(objAttach), 1)
            }
          }
          att.attFile = newFileList
        }
      })
    },

    async saveDraft() {
      const emailRegex =
        /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/
      const fatherEmail = this.faEmail.trim()
      const motherEmail = this.maEmail.trim()
      const guardianEmail = this.gdEmail.trim()
      const billingEmail = this.billEmail.trim()
      let ErrorMsg = ''
      if (this.selectOptParent === 'fnm') {
        this.$v.faEmail.$touch()
        this.$v.maEmail.$touch()
        if (fatherEmail.length === 0 || motherEmail.length === 0) {
          ErrorMsg = "Please provide either father's or mother's email address"
        } else {
          if (!emailRegex.test(fatherEmail) || !emailRegex.test(motherEmail)) {
            ErrorMsg = 'Invalid e-mail address'
          }
        }
      } else if (this.selectOptParent === 'father') {
        this.$v.faEmail.$touch()
        if (fatherEmail.length === 0) {
          ErrorMsg = "Please provide father's email address"
        } else {
          if (!emailRegex.test(fatherEmail)) {
            ErrorMsg = 'Invalid e-mail address'
          }
        }
      } else if (this.selectOptParent === 'mother') {
        this.$v.maEmail.$touch()
        if (motherEmail.length === 0) {
          ErrorMsg = "Please provide mother's email address"
        } else {
          if (!emailRegex.test(motherEmail)) {
            ErrorMsg = 'Invalid e-mail address'
          }
        }
      } else {
        if (guardianEmail.length === 0) {
          this.$v.gdEmail.$touch()
          ErrorMsg = "Please provide guardian's email address"
        } else {
          if (!emailRegex.test(guardianEmail)) {
            ErrorMsg = 'Invalid e-mail address'
          }
        }
      }
      if (ErrorMsg.trim().length > 0) {
        this.$notify.error({
          title: 'Error',
          message: ErrorMsg,
        })
        return
      }
      window.scrollTo(0, 0)
      await this.saveApplicationForm(true)
    },

    async setupDraft(apfId) {
      this.existingApfId = apfId
      await this.getTodayDate()
      await this.BindCountryList()
      await this.BindQuestion()
      await this.BindSchoolDropdown()
      await this.getDraftApplicationForm(this.existingApfId)
    },

    flashError(msg) {
      return this.$notify.error({ title: 'Error', message: msg })
    },

    checkAttachIsRequired(doc) {
      if (requiredMisApfDocumentChecklist.includes(doc)) {
        return '*'
      }
    },
  },

  computed: {
    validationErrors() {
      return Object.entries(this.$v).filter(([key, attr]) => attr?.$anyError)
    },
  },
}
</script>

<style>
@import './StudentApplicationForm.css';
</style>
